import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Permission {
  permissionName: string;
  // other properties...
}

const initialState = {
  permissions: [] as Permission[],
};

const permissionsSlice = createSlice({
  name: "permissionsData",
  initialState,
  reducers: {
    setPermissionsData: (state, action: PayloadAction<any[]>) => {
      state.permissions = action.payload;
      return state;
    },
  },
});

export const { setPermissionsData } = permissionsSlice.actions;
export default permissionsSlice.reducer;
